import { Head } from "@inertiajs/react"
import AdminLayout from "../../../layouts/AdminLayout"
import SentenceFormView, { SentenceForm } from "./Form"

type Props = { sentence: SentenceForm; topics: { id: number; name: string }[]; errors?: Record<string, string[]> }

export default function NewSentence({ sentence, topics, errors }: Props) {
  return (
    <AdminLayout title="New sentence">
      <Head title="New sentence" />
      <SentenceFormView sentence={sentence} topics={topics} errors={errors} />
    </AdminLayout>
  )
}
